import { useMediaQuery } from '@mui/material';
import BudgetPercentageInput from './BudgetPercentageInput';
import { formatCurrencyToNumber } from '../../../../utils/stringUtils';

interface IBudgetPercentageFieldsProps {
  volkstotalPercentage?: number;
  dealershipPercentage?: number;
  warrantyPercentage?: number;
  showPercentageFields?: boolean;
  isExternalService?: boolean;
  calculatedSubtotal: string;
  calculatedTruckerPayPlanSubtotal: string;
  onVolkstotalPercentageChange?: (value: number) => void;
  onDealershipPercentageChange?: (value: number) => void;
  onWarrantyPercentageChange?: (value: number) => void;
}

const BudgetPercentageFields = (props: IBudgetPercentageFieldsProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  if (props.showPercentageFields === false) {
    return null;
  }

  const dealership = props.dealershipPercentage || 0;
  const warranty = props.warrantyPercentage || 0;

  const truckerPayPlanSubtotal = formatCurrencyToNumber(props.calculatedTruckerPayPlanSubtotal);
  const subtotal = formatCurrencyToNumber(props.calculatedSubtotal);

  return (
    <div className={`flex ${isMobile ? 'flex-col' : 'flex-row'} gap-10 ${isMobile ? '' : 'flex-wrap'} items-start flex-shrink-0`}>
      <div className={`flex ${isMobile ? 'w-full' : 'w-full md:w-[160px]'} flex-col flex-shrink-0 ${isMobile ? 'mb-3' : 'mb-4'}`}>
        <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">% Cliente</div>
        <BudgetPercentageInput
          value={((subtotal ?? 0) - (truckerPayPlanSubtotal ?? 0)) / (subtotal ?? 0) * 100}
          onChange={() => {}}
          placeholder="00%"
          disabled={true}
        />
      </div>
      <div className={`flex ${isMobile ? 'w-full' : 'w-full md:w-[160px]'} flex-col flex-shrink-0 ${isMobile ? 'mb-3' : 'mb-4'}`}>
        <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">% Plano manutenção</div>
        <BudgetPercentageInput
          value={truckerPayPlanSubtotal / (subtotal ?? 0) * 100}
          onChange={() => {}}
          placeholder="00%"
          disabled={true}
          // onChange={(value) => props.onVolkstotalPercentageChange?.(value)}
          // max={Math.max(0, 100 - (dealership + warranty))}
        />
      </div>
      <div className={`flex ${isMobile ? 'w-full' : 'w-full md:w-[160px]'} flex-col flex-shrink-0 ${isMobile ? 'mb-3' : 'mb-4'}`}>
        <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">% Concessionária</div>
        <BudgetPercentageInput
          value={props.dealershipPercentage || 0}
          onChange={(value) => props.onDealershipPercentageChange?.(value)}
          placeholder="00%"
          max={Math.max(0, 100 - (truckerPayPlanSubtotal + warranty))}
          disabled={!props.isExternalService}
        />
      </div>
      <div className={`flex ${isMobile ? 'w-full' : 'w-full md:w-[160px]'} flex-col flex-shrink-0 ${isMobile ? 'mb-3' : 'mb-4'}`}>
        <div className="font-bold mb-2 text-size-12 text-gray-500 whitespace-nowrap">Garantia</div>
        <BudgetPercentageInput
          value={props.warrantyPercentage || 0}
          onChange={(value) => props.onWarrantyPercentageChange?.(value)}
          placeholder="00%"
          max={Math.max(0, 100 - (truckerPayPlanSubtotal + dealership))}
          disabled={!props.isExternalService}
        />
      </div>
    </div>
  );
};

export default BudgetPercentageFields;

